module.exports = __webpack_public_path__ + "static/media/adac.d6aabad4.jpg";